import React, { useState, useRef } from "react";
import { Button } from "primereact/button";
import ContactUs from "../component/ContactUs";
import Footer from "../component/Footer";
import { WizardAppartamentoVilla } from "../component/WizardAppartamentoVilla";
import NavBar from "../component/NavBar";
import ReactGA from "react-ga4";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBath,
  faHotel,
  faHouseCircleCheck,
  //faPlugCirclePlus,
  //faTemperatureArrowUp,
} from "@fortawesome/free-solid-svg-icons";
//import { faPersonShelter } from "@fortawesome/free-solid-svg-icons/faPersonShelter";

const Home = () => {
  ReactGA.send({ hitType: "pageview", page: "/home", title: "Home" });
  const myAnchorRef = useRef(null);

  const handleClickContatti = () => {
    myAnchorRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const [visiblePreventivo, setVisiblePreventivo] = useState(false);
  const [tipologia, setTipologia] = useState("");

  const openWizardPreventivo = (tipologia) => {
    setVisiblePreventivo(true);
    setTipologia(tipologia);
  };


  const offerte = (
    <section className="surface-50 relative flex flex-column overflow-hidden justify-content-center align-items-center gap-6 px-4 py-8 md:px-6 lg:px-8">
      <header className="flex align-items-center justify-content-center flex-column gap-2">
        
        <h2 className="m-0 font-bold text-4xl line-height-3 text-900"></h2>
        <p className="text-xl line-height-3 text-700 mt-0 mb-0">
          Trasforma il tuo spazio senza sorprese: tariffe chiare per
          ristrutturazioni su misura
        </p>
        <h1 className="m-0 text-4xl text-blue-600 font-bold mb-3 line-height-3 ">
          OFFERTA
        </h1>
      </header>
      <div className="flex flex-column lg:flex-row z-1 justify-content-center gap-5">
        <article className="flex flex-column gap-4 p-4 surface-0 border-round-lg shadow-2">
          <div className="flex justify-content-between align-items-center border-bottom-1 surface-border pb-4 gap-5">
            <div className="flex flex-column gap-2">
              <h3 className="m-0 font-semibold text-2xl text-900">
                Appartamento fino 40 mq
              </h3>
            </div>
            <div className="flex align-items-center gap-2">
              <span className="font-semibold text-4xl text-900">
                <span className="text-xl">€</span>17.000
              </span>{" "}
            </div>
          </div>
          <div className="flex flex-column gap-3 border-bottom-1 surface-border pb-4">
            <h3 className="m-0 mb-2 font-semibold text-base text-900">
              Piano offerta include:{" "}
            </h3>
            <div className="flex flex-column sm:flex-row w-full justify-content-between gap-4">
              <ul className="list-none mt-2 mb-0 p-0">
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Demolizione pavimenti
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Rimozione impianti
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Posa pavimenti e rivestimenti
                  </p>
                </li>
                <li>
                  <p className="mb-0 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Imbiancatura
                  </p>
                </li>
              </ul>
              <ul className="list-none mt-0 mb-0 sm:mt-2 p-0">
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Realizzazione impianti
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Rifacimento bagno
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Rifacimento cucina
                  </p>
                </li>
                <li>
                  <p className="mb-0 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Installazione e collegamenti
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <Button
              label="Contattaci"
              className="w-full"
              onClick={() => handleClickContatti()}
            ></Button>
          </div>
        </article>
        <article className="flex flex-column gap-4 p-4 surface-0 border-round-lg shadow-2">
          <div className="flex justify-content-between align-items-center border-bottom-1 surface-border pb-4 gap-5">
            <div className="flex flex-column gap-2">
              <h3 className="m-0 font-semibold text-2xl text-900">
                Appartamento fino 50 mq
              </h3>
            </div>
            <div className="flex align-items-center gap-2">
              <span className="font-semibold text-4xl text-900">
                <span className="text-xl">€</span>23.900
              </span>{" "}
            </div>
          </div>
          <div className="flex flex-column gap-3 border-bottom-1 surface-border pb-4">
            <h3 className="m-0 mb-2 font-semibold text-base text-900">
              Piano offerta include:{" "}
            </h3>
            <div className="flex flex-column sm:flex-row w-full justify-content-between gap-4">
              <ul className="list-none mt-2 mb-0 p-0">
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Demolizione pavimenti
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Rimozione impianti
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Posa pavimenti e rivestimenti
                  </p>
                </li>
                <li>
                  <p className="mb-0 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Imbiancatura
                  </p>
                </li>
              </ul>
              <ul className="list-none mt-0 mb-0 sm:mt-2 p-0">
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Realizzazione impianti
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Rifacimento bagno
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Rifacimento cucina
                  </p>
                </li>
                <li>
                  <p className="mb-0 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Installazione e collegamenti
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <Button
              label="Contattaci"
              className="w-full"
              onClick={() => handleClickContatti()}
            ></Button>
          </div>
        </article>
        <article className="flex flex-column gap-4 p-4 surface-0 border-round-lg shadow-2">
          <div className="flex justify-content-between align-items-center border-bottom-1 surface-border pb-4 gap-5">
            <div className="flex flex-column gap-2">
              <h3 className="m-0 font-semibold text-2xl text-900">
                Ristrutturazione Bagno fino a 6 mq
              </h3>
            </div>
            <div className="flex align-items-center gap-2">
              <span className="font-semibold text-4xl text-900">
                <span className="text-xl">€</span>9.500
              </span>{" "}
            </div>
          </div>
          <div className="flex flex-column gap-3 border-bottom-1 surface-border pb-4">
            <h3 className="m-0 mb-2 font-semibold text-base text-900">
              Piano offerta include:{" "}
            </h3>
            <div className="flex flex-column sm:flex-row w-full justify-content-between gap-4">
              <ul className="list-none mt-2 mb-0 p-0">
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Demolizione
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Rimozione impianti
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Posa pavimenti e rivestimenti
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center"></p>
                </li>
              </ul>
              <ul className="list-none mt-0 mb-0 sm:mt-2 p-0">
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Realizzazione impianti
                  </p>
                </li>
                <li>
                  <p className="mb-0 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Installazione e collegamenti
                  </p>
                </li>
                <br />
                <li>
                  <p className="mb-0 mt-0 text-600 flex align-items-center">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>{" "}
                    Intonacatura Rasatura e Imbiancatura
                  </p>
                </li>
                <li>
                  <p className="mb-4 mt-0 text-600 flex align-items-center"></p>
                </li>
                <li>
                  
                  <br />
                  <br />
                </li>
              </ul>
            </div>
          </div>
          <div>
            <Button
              label="Contattaci"
              className="w-full"
              onClick={() => handleClickContatti()}
            ></Button>
          </div>
        </article>
      </div>
      <div
        className="absolute top-50 w-screen"
        style={{ transform: "rotate(-6deg)" }}
      >
        <div className="h-4rem bg-primary-500"></div>
        <div className="h-4rem bg-primary-300"></div>
        <div className="h-4rem bg-primary-100"></div>
      </div>
    </section>
  );
  const hero = (
    <div className="grid grid-nogutter surface-section text-800 p-4">
      <div className="col-12 md:col-6 p-2 mt-3 text-center md:text-left flex align-items-start ">
        <section>
          <span className="block text-6xl font-bold mb-1">
            Rinnova il tuo spazio,
          </span>
          <div className="text-6xl text-blue-600 font-bold mb-3">
            trasforma la tua vita
          </div>
          <p className="mt-0 mb-4 text-700 line-height-3">
            Se siete alla ricerca di una ditta di ristrutturazione edile
            affidabile e competente in Lombardia, siete nel posto giusto.
            Trasformiamo i vostri spazi, rendendo i vostri sogni di casa ideale
            una splendida realtà
          </p>
          <Button
            label="Genera il tuo preventivo"
            type="button"
            className="mr-3 p-button-raised"
            onClick={() => setVisiblePreventivo(true)}
          ></Button>
          <p className="mt-0 pt-6 mb-4 text-700 line-height-3">
            Chiedi un sopralluogo gratuito per un preventivo personalizzato
          </p>
          <Button
            label="Chiedi sopralluogo"
            type="button"
            icon="pi pi-whatsapp"
            className="mr-3 p-button-raised"
            onClick={() => window.open("https://wa.me/393284874103", "_blank")}
          />
        </section>
      </div>
       
      <div className="col-12 md:col-6 overflow-hidden">
        {/**video hero
        <video
          autoPlay
          loop
          muted
          playsInline
          //controls
          //autoPlay
          //loop
          //muted
          //poster="assets/immagini/portfolio/villetta_cassina_pecchi/poster_villetta.jpeg"
          //alt="Hero Video"
          className="w-full"
          style={{ height: "550px", width: "100%", objectFit: "cover" }}
        >
          <source
            src="assets/immagini/portfolio/villetta_cassina_pecchi/video_villetta.mp4"
            type="video/mp4"
          />
          Il tuo browser non supporta il tag video.
        </video>*/}
       
        <img
          src="assets/immagini/hero1.webp"
          alt="cantiere"
          width="100%"
          height="100%"
          className="md:ml-auto block md:h-full"
          style={{
            clipPath: "polygon(8% 0, 100% 0%, 100% 100%, 0 100%)",
          }}
        />
      </div>
    </div>
  );

  const vantaggi = (
    <div className="surface-section px-4 py-8 md:px-6 text-center">
      <div className="mb-3 font-bold text-3xl">
        <span className="text-900">Perché scegliere noi?</span>
      </div>
      <div className="text-700 mb-6">
        Offriamo una vasta gamma di servizi di ristrutturazione con vantaggi
        unici
      </div>
      <div className="grid">
        <div className="col-12 md:col-4 mb-4 px-5">
          <span
            className="p-3 shadow-2 mb-3 inline-block surface-card"
            style={{ borderRadius: "10px" }}
          >
            <FontAwesomeIcon
              icon={faHouseCircleCheck}
              style={{ color: "#3b82f6" }}
              size="2x"
            />
          </span>
          <div className="text-900 text-xl mb-3 font-medium">
            Ristrutturazioni complete di interni ed esterni
          </div>
          <span className="text-700 line-height-3">
            Rinnova completamente la tua abitazione o il tuo spazio commerciale,
            dall'interno all'esterno. Trasforma ogni dettaglio per creare un
            ambiente che rifletta il tuo stile unico e le tue esigenze
          </span>
        </div>
        <div className="col-12 md:col-4 mb-4 px-5">
          <span
            className="p-3 shadow-2 mb-3 inline-block surface-card"
            style={{ borderRadius: "10px" }}
          >
            <FontAwesomeIcon
              icon={faBath}
              style={{ color: "#3b82f6" }}
              size="2x"
            />
          </span>
          <div className="text-900 text-xl mb-3 font-medium">
            Rifacimento bagni e cucine
          </div>
          <span className="text-700 line-height-3">
            Dalla demolizione alla nuova installazione, trasforma questi spazi
            cruciali della tua casa con materiali di qualità e un'attenzione
            particolare alla funzionalità e all'estetica.
          </span>
        </div>
        <div className="col-12 md:col-4 mb-4 px-5">
          <span
            className="p-3 shadow-2 mb-3 inline-block surface-card"
            style={{ borderRadius: "10px" }}
          >
            <FontAwesomeIcon
              icon={faHotel}
              style={{ color: "#3b82f6" }}
              size="2x"
            />
          </span>
          <div className="text-900 text-xl mb-3 font-medium">
            Restauro di facciate e esterni
          </div>
          <span className="text-700 line-height-3">
            Attraverso interventi mirati e materiali di qualità, restituiamo
            loro la bellezza originale, garantendo resistenza e durabilità nel
            tempo
          </span>
        </div>
      </div>
    </div>
  );

  const testimonianze = (
    <div className="surface-section px-4 py-8 md:px-6 text-center">
      <div className="mb-3 font-bold text-3xl">
        <span className="text-900">Cosa dicono i nostri clienti</span>
      </div>
      <div className="text-700 mb-6">
        Le testimonianze dei nostri clienti soddisfatti
      </div>
      <div className="grid">
        <div className="col-12 md:col-4 mb-4 px-5">
          <div
            className="p-3 shadow-2 mb-3 inline-block surface-card"
            style={{ borderRadius: "10px" }}
          >
            <p className="text-700 line-height-3">
              "La nostra esperienza con questa ditta di ristrutturazione è stata
              eccezionale. Hanno trasformato la nostra casa in un sogno!"
            </p>
            <div className="text-900 text-xl mb-3 font-medium">- Mario</div>
          </div>
        </div>
        <div className="col-12 md:col-4 mb-4 px-5">
          <div
            className="p-3 shadow-2 mb-3 inline-block surface-card"
            style={{ borderRadius: "10px" }}
          >
            <p className="text-700 line-height-3">
              "Servizio eccellente e professionale. Consiglio vivamente questa
              ditta per qualsiasi lavoro di ristrutturazione."
            </p>
            <div className="text-900 text-xl mb-3 font-medium">- Laura</div>
          </div>
        </div>
        <div className="col-12 md:col-4 mb-4 px-5">
          <div
            className="p-3 shadow-2 mb-3 inline-block surface-card"
            style={{ borderRadius: "10px" }}
          >
            <p className="text-700 line-height-3">
              "Hanno fatto un lavoro fantastico nel rifare il nostro bagno e la
              cucina. Siamo molto soddisfatti del risultato finale."
            </p>
            <div className="text-900 text-xl mb-3 font-medium">- Giovanni</div>
          </div>
        </div>
      </div>
    </div>
  );

  const callActionGeneraPreventivo = (
    <div className="surface-section px-4 pb-8 md:px-6">
      <div
        className="p-6 shadow-2 flex flex-column md:flex-row align-items-center justify-content-between"
        style={{
          borderRadius: "1rem",
          background:
            "linear-gradient(0deg, rgba(0, 123, 255, 0.5), rgba(0, 123, 255, 0.5)), linear-gradient(92.54deg, #1C80CF 47.88%, #FFFFFF 100.01%)",
        }}
      >
        <div className="pr-6">
          <div className="text-blue-100 font-medium text-xl mb-3">
            OTTIENI IL TUO PREVENTIVO ONLINE
          </div>
          <div className="text-white font-medium text-5xl">
            Genera il tuo preventivo in soli 5 min
          </div>
        </div>
        <div className="mt-4 mr-auto md:mt-0 md:mr-0">
          <Button
            label="GENERA"
            onClick={() => setVisiblePreventivo(true)}
            className="font-bold px-5 py-3 p-button-warning p-button-rounded p-button-raised white-space-nowrap"
          />
        </div>
      </div>
    </div>
  );

  return (
    <>
      <NavBar
        goToContatti={handleClickContatti}
        openPreventivo={(tipologia) => openWizardPreventivo(tipologia)}
      />
      
{/*
      <div className="hero">
        <Button
          label="Contattaci"
          type="button"
          className=""
          onClick={handleClickContatti}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      </div>*/}
      <div className="hero">
        <Button
          label="Contattaci"
          type="button"
          className="p-button-raised "
          onClick={handleClickContatti}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      </div>
      {hero}
      {offerte}
      {vantaggi}
      {testimonianze}
      {callActionGeneraPreventivo}
      <div ref={myAnchorRef}>
        <ContactUs />
      </div>
      <Footer openPreventivo={(tipologia) => openWizardPreventivo(tipologia)} />
      {visiblePreventivo && (
        <WizardAppartamentoVilla
          tipologia={tipologia}
          onExit={() => setVisiblePreventivo(false)}
        />
      )}
    </>
  );
};

export default Home;
